import { PlusIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import { usePermissions } from "../../context/PermissionsContext";
import { createJob } from "../../services/jobs/createJob";
import CreateJobsForServiceSection from "../TaskForm/CreateJobsForServiceSection";
import { term } from "../../terms";

function CreateJob({ setIsModalOpen, getNewJobs }) {
    const { can } = usePermissions();
    const [service, setService] = useState({
        name: "",
    });
    const [jobs, setJobs] = useState([]);
    const canWritePipelines = can("pipelines.write");
    const noPermissionMessage = "You don't have permission to do this.";

    const IntialStates = () => {
        setService({
            name: "",
        });
        setJobs([]);
    };

    const addNewJob = () => {
        if (!canWritePipelines) return;
        setJobs([
            ...jobs,
            {
                id: jobs.length,
                name: "",
                editing: true,
                checklistItems: [{ id: 0, name: "", editing: true }],
            },
        ]);
    };

    const saveDetails = async () => {
        if (!canWritePipelines) {
            toast.error(noPermissionMessage);
            return;
        }

        if (service.name == "") {
            toast.error("Service name can't be empty");
            return;
        }

        if (jobs.length == 0 || (jobs.length == 1 && jobs[0].editing == true)) {
            toast.error("You need to add at least one step.");
            return;
        }
        const newJobs = jobs
            .filter((job) => job.editing == false)
            .map((job) => {
                return {
                    name: job.name,
                    order: job.id,
                    checklistItems: job.checklistItems,
                };
            });

        const servicesWithJobs = {
            name: service.name,
            tasks: newJobs,
        };

        console.log("Services with jobs:", servicesWithJobs);

        const response = await createJob(servicesWithJobs);
        if (response.data.success) {
            toast.success(response.data.message);
            IntialStates();
            setIsModalOpen?.(false);
            getNewJobs?.();
        } else {
            toast.error(response.data.message);
        }
        console.log(servicesWithJobs);
    };

    return (
        <section>
            <Toaster />
            <ReactTooltip
                type="light"
                effect="solid"
                place="top"
                border={true}
                borderColor={"rgb(220,220,220)"}
                className="rounded-md bg-gray-50"
                multiline={false}
            />

            <main className="justify-center w-full overflow-auto">
                <div className="px-4 py-8 sm:px-6 lg:px-8 ">
                    <div className="relative flex-col items-center">
                        {/* Page header */}
                        <div className="flex justify-center">
                            {/* Left: Title */}
                            {/* <div className="mb-4 sm:mb-0">
                                <h3 className="font-bold text-md text-slate-800">
                                    New {term("pipeline_singular")}
                                </h3>
                            </div> */}
                        </div>

                        <div className="w-full bg-white border rounded-sm shadow-lg border-slate-200">
                            <div className="px-5 py-4 space-y-5">
                                <div>
                                    <label
                                        htmlFor="email"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        Name
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            onChange={(e) =>
                                                setService({
                                                    ...service,
                                                    name: e.target.value,
                                                })
                                            }
                                            value={service.name}
                                            disabled={!canWritePipelines}
                                            className="w-full p-1 px-2 border rounded-sm shadow-sm border-slate-200 focus:ring-0 focus:outline-none"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative mt-12 bg-white border rounded-sm shadow-lg border-slate-200">
                            <header className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
                                <h2 className="font-semibold text-slate-800">
                                    {term("step_plural")}{" "}
                                    <span className="text-sm font-light text-slate-700">
                                        click & drag to re order
                                    </span>
                                </h2>
                                <span
                                    data-tip={
                                        canWritePipelines
                                            ? `Add ${term("step_singular")}`
                                            : noPermissionMessage
                                    }
                                    className="inline-flex"
                                >
                                    <button
                                        id="add-btn"
                                        onClick={() => {
                                            addNewJob();
                                        }}
                                        type="button"
                                        disabled={!canWritePipelines}
                                        className={`inline-flex items-center p-2 text-white bg-teal-500 border border-transparent rounded-sm shadow-sm ${
                                            canWritePipelines
                                                ? "hover:bg-teal-600"
                                                : "opacity-50 cursor-not-allowed"
                                        }`}
                                    >
                                        <PlusIcon className="w-5 h-5" />
                                    </button>
                                </span>
                            </header>

                            <CreateJobsForServiceSection
                                jobs={jobs}
                                setJobs={setJobs}
                            />
                        </div>
                        <div className="flex justify-end w-full">
                            <span
                                data-tip={canWritePipelines ? "Save" : noPermissionMessage}
                                className="inline-flex"
                            >
                                <button
                                    onClick={() => saveDetails()}
                                    disabled={!canWritePipelines}
                                    className={`z-50 inline-flex justify-center px-4 py-2 mt-4 ml-3 text-sm font-medium text-white bg-teal-500 border border-transparent rounded-sm shadow-sm ${
                                        canWritePipelines
                                            ? "hover:bg-teal-600"
                                            : "opacity-50 cursor-not-allowed"
                                    } focus:outline-none focus:ring-0`}
                                >
                                    Save
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </main>
        </section>
    );
}
export default CreateJob;
